import React, { useState } from 'react';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function EditTranscript({ caseData, onUpdate }) {
  const [formData, setFormData] = useState({
    applicant_name: caseData.applicant_name || '',
    date_of_birth: caseData.date_of_birth || '',
    father_name: caseData.father_name || '',
    mother_name: caseData.mother_name || '',
    email: caseData.email || '',
    mobile: caseData.mobile || '',
    alternate_contact: caseData.alternate_contact || '',
    college_name: caseData.college_name || '',
    college_location: caseData.college_location || '',
    campus_name: caseData.campus_name || '',
    education_type: caseData.education_type || '',
    course_name: caseData.course_name || '',
    register_roll_no: caseData.register_roll_no || '',
    year_of_admission: caseData.year_of_admission || '',
    year_of_graduation: caseData.year_of_graduation || '',
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      await api.cases.update(caseData.id, formData);
      toast.success('Case updated successfully');
      onUpdate();
    } catch (error) {
      toast.error('Failed to update case');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      applicant_name: caseData.applicant_name || '',
      date_of_birth: caseData.date_of_birth || '',
      father_name: caseData.father_name || '',
      mother_name: caseData.mother_name || '',
      email: caseData.email || '',
      mobile: caseData.mobile || '',
      alternate_contact: caseData.alternate_contact || '',
      college_name: caseData.college_name || '',
      college_location: caseData.college_location || '',
      campus_name: caseData.campus_name || '',
      education_type: caseData.education_type || '',
      course_name: caseData.course_name || '',
      register_roll_no: caseData.register_roll_no || '',
      year_of_admission: caseData.year_of_admission || '',
      year_of_graduation: caseData.year_of_graduation || '',
    });
  };

  const studentFields = [
    { name: 'applicant_name', label: 'Applicant Name' },
    { name: 'date_of_birth', label: 'Date of Birth' },
    { name: 'father_name', label: 'Father Name' },
    { name: 'mother_name', label: 'Mother Name' },
  ];

  const contactFields = [
    { name: 'email', label: 'Email' },
    { name: 'mobile', label: 'Mobile' },
    { name: 'alternate_contact', label: 'Alternate Contact' },
  ];

  const educationFields = [
    { name: 'college_name', label: 'College Name' },
    { name: 'college_location', label: 'College Location' },
    { name: 'campus_name', label: 'Campus Name' },
    { name: 'education_type', label: 'Education Type' },
    { name: 'course_name', label: 'Course Name' },
    { name: 'register_roll_no', label: 'Register / Roll No' },
    { name: 'year_of_admission', label: 'Year of Admission' },
    { name: 'year_of_graduation', label: 'Year of Graduation' },
  ];

  const renderFieldGroup = (fields, title) => (
    <div className="transcript-section">
      <h3 className="transcript-section-title">{title}</h3>
      <div className="transcript-fields-grid">
        {fields.map((field) => (
          <div key={field.name} className="form-group">
            <label htmlFor={field.name} className="form-label">
              {field.label}
            </label>
            <input
              id={field.name}
              type="text"
              name={field.name}
              value={formData[field.name]}
              onChange={handleInputChange}
              className="form-input"
            />
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="edit-transcript-form">
      {renderFieldGroup(studentFields, 'Student Information')}
      {renderFieldGroup(contactFields, 'Contact Information')}
      {renderFieldGroup(educationFields, 'Education Information')}

      <div className="form-actions">
        <button
          className="btn btn-secondary"
          onClick={handleCancel}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </div>
  );
}
